import { Map } from "immutable";

export const blockRenderMap = Map({
  "header-one": {
    element: "h1",
  },
  "header-two": {
    element: "h2",
  },
  "header-three": {
    element: "h3",
  },
  "header-four": {
    element: "h4",
  },
  paragraph: {
    element: "span",
  },
  unstyled: {
    element: "span",
  },
});
